import { render, staticRenderFns } from "./LlTosText.vue?vue&type=template&id=2c65c0c2&scoped=true&"
import script from "./LlTosText.vue?vue&type=script&lang=js&"
export * from "./LlTosText.vue?vue&type=script&lang=js&"
import style0 from "./LlTosText.vue?vue&type=style&index=0&id=2c65c0c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c65c0c2",
  null
  
)

export default component.exports